import { render } from "./CustomerUserIndexComponent.vue?vue&type=template&id=0435d8e7"
import script from "./CustomerUserIndexComponent.vue?vue&type=script&lang=js"
export * from "./CustomerUserIndexComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__